import { render } from "./NoteDialog.vue?vue&type=template&id=b3ffeb1c"
import script from "./NoteDialog.vue?vue&type=script&lang=js"
export * from "./NoteDialog.vue?vue&type=script&lang=js"

import "./NoteDialog.vue?vue&type=style&index=0&id=b3ffeb1c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__